import './DateRangePicker.css';
import './CalendarSkeleton.css';

/**
 * Calendar skeleton loader that maintains proper dimensions while loading
 *
 * This component mimics the structure of react-day-picker to prevent layout shift
 */
export function CalendarSkeleton() {
	return (
		<div
			className="rdp-root gpb-calendar-skeleton"
			data-mode="single"
			{...({ inert: '' } as any)}
		>
			<div className="rdp-months">
				<nav className="rdp-nav" aria-label="">
					<button
						type="button"
						className="rdp-button_previous"
						disabled
						aria-label=""
					/>
					<button
						type="button"
						className="rdp-button_next"
						disabled
						aria-label=""
					/>
				</nav>
				<div className="rdp-month">
					<div className="rdp-month_caption">
						<div className="rdp-dropdowns">
							<span
								data-disabled="true"
								className="rdp-dropdown_root"
							>
								<select
									className="rdp-dropdown rdp-months_dropdown"
									disabled
									aria-label=""
								>
									<option value="0"> </option>
								</select>
								<span
									className="rdp-caption_label"
									aria-hidden="true"
								></span>
							</span>
							<span
								data-disabled="true"
								className="rdp-dropdown_root"
							>
								<select
									className="rdp-dropdown rdp-years_dropdown"
									disabled
									aria-label=""
								>
									<option value="2024"> </option>
								</select>
								<span
									className="rdp-caption_label"
									aria-hidden="true"
								></span>
							</span>
						</div>
					</div>
					<table role="grid" className="rdp-month_grid">
						<thead aria-hidden="true">
							<tr className="rdp-weekdays">
								{[...Array(7)].map((_, i) => (
									<th
										key={i}
										className="rdp-weekday"
										scope="col"
									></th>
								))}
							</tr>
						</thead>
						<tbody className="rdp-weeks">
							{[...Array(6)].map((_, weekIndex) => (
								<tr key={weekIndex} className="rdp-week">
									{[...Array(7)].map((_, dayIndex) => (
										<td
											key={dayIndex}
											className="rdp-day"
											role="gridcell"
										>
											<button
												className="rdp-day_button"
												type="button"
												disabled
												tabIndex={-1}
											></button>
										</td>
									))}
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
}
